const cvExperience = [
  {
    company: "Speridian Technologies",
    country: "Toronto, Canada",
    year: "December 2025 - Present",
    role: "Full Stack Engineer",
    summary:
      "Contributed to the modernization of the SpendSafe platform by migrating a legacy Laravel/PHP monolithic backend to a scalable microservices architecture using NestJS and TypeScript.",
    details: [
      "Designed and implemented backend services supporting core platform capabilities such as authentication, user management, notifications, and payment processing.",
      "Developed and maintained RESTful APIs with NestJS, ensuring compatibility with existing Laravel endpoints during the migration process.",
      "Implemented event-driven communication using AWS SQS, enabling asynchronous workflows across services.",
      "Managed data persistence using TypeORM, MySQL, and Redis, and collaborated on containerization and CI/CD processes using Docker and Azure DevOps."
    ]
  },
  {
    company: "Homebor",
    country: "Toronto, Canada",
    year: "July 2025 - December 2025",
    role: "Software Developer",
    summary:
      "Contributed to the development of Homebor, a homestay management platform connecting international students with host families.",
    details: [
      "Built modular and reusable React (TypeScript) components, integrating with Figma MCP to ensure design consistency and faster UI development.",
      "Developed and integrated RESTful APIs using NestJS, collaborating on backend architecture and module communication.",
      "Participated in deployment and infrastructure setup using Docker, Azure, and AWS to support scalability and reliability.",
      "Leveraged AI-assisted development tools to accelerate implementation and improve front-end productivity."
    ]
  },
  {
    company: "Venture Software Services",
    country: "Santiago, Chile",
    year: "September 2024 - May 2025",
    role: "Software Engineer",
    summary:
      "Designed and developed web applications from scratch, managing the full project lifecycle from requirements gathering to deployment.",
    details: [
      "Built front-end applications using React, Redux, Hooks, and Vite, improving performance and maintainability across devices.",
      "Implemented accessibility best practices, including ARIA attributes and focus management for inclusive user experiences.",
      "Developed backend services using NestJS, REST APIs, and Redis caching, improving system response times.",
      "Deployed applications on Digital Ocean, reducing infrastructure costs by 15% while maintaining system stability."
    ]
  },
  {
    company: "Sky Airline",
    country: "Santiago, Chile",
    year: "July 2022 - June 2024",
    role: "Full Stack Developer",
    summary:
      "Contributed to the development of a scalable airline ticket sales platform, working across both front-end and back-end services.",
    details: [
      "Built dynamic UI components using React, Redux, and Storybook, improving state management and interface consistency.",
      "Developed backend modules using NestJS, including services for electronic ticket generation and PDF processing.",
      "Implemented asynchronous messaging using RabbitMQ (Publisher/Subscriber) to support communication between services.",
      "Worked with MongoDB, Jest, and Kubernetes deployments, contributing to system stability and monitoring."
    ]
  },
];

export default cvExperience;
